import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES, ROLES } from '@/constants';
import { useAuth } from '@/context';

const SECTIONS = [
  { base: ROUTES.TOURNAMENTS, label: 'Tournaments' },
  { base: ROUTES.TEAMS, label: 'Teams' },
  { base: ROUTES.PLAYERS, label: 'Players' },
  { base: ROUTES.MATCHES, label: 'Matches' },
  { base: ROUTES.GROUNDS, label: 'Grounds' },
  { base: ROUTES.GALLERY, label: 'Gallery' },
  { base: ROUTES.NOTIFICATIONS, label: 'Notifications' },
  { base: ROUTES.SPONSORS, label: 'Sponsors' },
  { base: ROUTES.REPORTS, label: 'Reports' },
  { base: ROUTES.SETTINGS, label: 'Settings' },
  { base: '/live-score', label: 'Live Score', leaf: true },
];

function getDetailLabel(pathname, base) {
  if (pathname === base) return null;
  if (pathname.endsWith('/new')) return 'Create';
  if (pathname.endsWith('/edit')) return 'Edit';
    if (pathname.includes('/notifications')) return 'Notifications';
    if (pathname.includes('/settings')) {
    if (pathname.includes('/users')) return 'Users';
    if (pathname.includes('/roles')) return 'Roles';
    if (pathname.includes('/profile')) return 'Profile';
    if (pathname.includes('/preferences')) return 'Preferences';
    if (pathname.includes('/notifications')) return 'Notifications';
    if (pathname.includes('/security')) return 'Security';
  }
  if (pathname.includes('/settings')) return 'Settings';
  if (pathname.includes('/settings')) return 'Settings';
  if (pathname.includes('/statistics')) return 'Statistics';
  if (pathname.includes('/gallery')) {
    if (pathname.includes('/albums')) return 'Albums';
    if (pathname.includes('/upload')) return 'Upload';
    return 'Gallery';
  }
  return 'Details';
}

export function useAdminBreadcrumbs() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const isScorer = user?.role === ROLES.SCORER;

  return useMemo(() => {
    const items = isScorer
      ? [{ label: 'My Matches', href: ROUTES.MATCHES }]
      : [{ label: 'Dashboard', href: ROUTES.DASHBOARD }];

    if (pathname === ROUTES.DASHBOARD || (isScorer && pathname === ROUTES.MATCHES)) {
      return items;
    }

    const section = SECTIONS.find(
      (entry) => pathname === entry.base || pathname.startsWith(`${entry.base}/`)
    );

    if (!section) {
      return items;
    }

    if (section.leaf) {
      items.push({ label: section.label });
      return items;
    }

    if (!(isScorer && section.base === ROUTES.MATCHES)) {
      items.push({ label: section.label, href: section.base });
    }

    const detailLabel = getDetailLabel(pathname, section.base);
    if (detailLabel) {
      items.push({ label: detailLabel });
    }

    return items;
  }, [pathname, isScorer]);
}
